import styled from "styled-components";
import { colors, device } from "../../utils";

const Wrapper
	= styled.div`
		.top-info {
			@media ${device.mobileP} {
				flex-direction: column;
			}
			@media ${device.mobileL} {
				flex-direction: column;
			}

			display: flex;
			flex-direction: row;
			gap: calc(8px + .4vw);
			font-size: 92%;
			font-weight: 600;

			.lab-lv {
			}

			.capacity {
			}
		}

		.traits-wrapper {
			overflow: auto;
			white-space: nowrap;
			padding: calc(10px + .3vw) ;
			margin-top: calc(10px + .3vw);

			/* width */
			::-webkit-scrollbar {
				height: 5px;
			}

			/* Track */
			::-webkit-scrollbar-track {
				background: rgba(255,255,255, .1);
				border-radius: 20px;
			}

			/* Handle */
			::-webkit-scrollbar-thumb {
				background: ${colors.info};
				border-radius: 10px;
			}



			> div {
				margin-right: 10px;
			}
		}
	`

export default Wrapper
